export enum TipoCorretagemEnum {
    FIXA,
    VOLUME
}